import { makeStyles } from '@material-ui/core/styles';

export const useFormOperatorStyles = makeStyles(theme => ({
  formOperator: {
    flexGrow: 1
  }
}));
